<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<template>
					<v-card
					class="mx-auto elevation-8"
					color=""
					max-width="800"
					>
					<v-card-title class="white--text lighten-4" style="background-color: black;">
						<v-icon
						large
						left
						>
						mdi-twitter
					</v-icon>
					<span class="title font-weight-light">Value Calculator</span>
				</v-card-title>

				<v-card-text class="headline font-weight-bold">
					<v-row>
						<v-col cols="12" sm="6" xs="4">
							<p>Enter Your Details</p>
							<v-col cols="6">
								<v-text-field
								type="number"
								v-model="employees"
								label="# Of Employees"
								></v-text-field>
								<v-text-field
								type="number"
								v-model="hourly"
								label="Employees Avg Hourly Wage"
								></v-text-field>
							</v-col>
							<v-radio-group v-model="selectedPlan">
								<p>Choose Plan</p>
								<v-spacer></v-spacer>
								<v-radio
								label="7832 Annually (5% off)"
								:value="1"
								></v-radio>
								<v-radio
								label="687 Monthly"
								:value="2"
								></v-radio>
							</v-radio-group>
						</v-col>


						<v-col cols="12" sm="6" xs="8">
							<v-card class="elevation-8">
								<v-container>
									<v-card-title>Investment</v-card-title>
									<div class="ml-3">
										<div class="subtitle-1 font-weight-bold">
											Daily rate per Employee: {{costDay}} Cents
										</div>
										<div class="subtitle-1 font-weight-bold">
											Monthly rate per Employee: {{costMonth}}
										</div>
										<div class="subtitle-1 font-weight-bold mb-3">
											Yearly rate per Employee: {{costYear}}
										</div>
									</div>
									<div>

										<v-card-title class="pb-0">Results</v-card-title>
										<v-card class="elevation-1">
											<v-card-title>Savings For Company</v-card-title>
											<v-card-text>
												<div class="subtitle-1 font-weight-bold">
													* Time Saved {{timeFrame}}: {{timeSaved * employees}} Hours
												</div>
												<div class="subtitle-1 font-weight-bold">
													* Wages Saved {{timeFrame}}: ${{companySavings}}
												</div>
											</v-card-text>
										</v-card>

										<v-card class="mb-3 elevation-1">
											<v-card-title>Savings Per Employee</v-card-title>
											<v-card-text>
												<div class="subtitle-1 font-weight-bold">
													* Time Saved {{timeFrame}}: {{timeSaved}} Hours
												</div>
												<div class="subtitle-1 font-weight-bold">
													* Wages Saved {{timeFrame}}: ${{timeSaved * hourly}}
												</div>
											</v-card-text>
										</v-card>
										<h5>Extra Value: <v-icon>show_chart</v-icon></h5>
										<div class="subtitle-1 font-weight-bold mt-3">
											Revenue From Closing Higher: <span class="circle">?????</span>
										</div>
										<div class="subtitle-1 font-weight-bold mt-3">
											Revenue From Increased Callbacks: <span class="circle">?????</span>
										</div>
									</div>
								</v-container>
							</v-card>
						</v-col>

						<v-col cols="12">
							<div class="subtitle-2 text-right">
								<div>
									* Calculations based on saving an average of 45 minutes a day 5 days a week.<br />
									(assuming the tech runs 3 calls and turns 20 minutes of writing options into 5)
								</div>
								<div class="mt-3">
									** Individual companies results will vary.
								</div>
							</div>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions>

				</v-card-actions>
			</v-card>
		</template>
	</v-col>
</v-row>
</v-container>
</template>
<script>
import firebase from 'firebase';
export default {
	name: 'Calculator',
	data() {
		return {
			dialog: false,
			employees: 50,
			selectedPlan: 1,
			hourly: 24,
			annualy: 7832,
			monthly: 687,
		}
	},
	computed: {
		costDay(){
			let sum = this.costYear / 365
			return sum.toFixed(2)
		},
		costMonth(){
			let sum = this.costYear / 12
			return sum.toFixed(2)
		},
		costYear(){
			let sum;
			if (this.selectedPlan == 1){
				sum = this.annualy / this.employees
			} 
			if (this.selectedPlan == 2) {
				sum = (this.monthly * 12) / this.employees
			}
			return sum.toFixed(2)
		},
		timeFrame(){
			return this.selectedPlan == 1 ? 'Annually' : 'Monthly'
		},
		timeSaved(){
			let time;
			if (this.selectedPlan == 1){
				time = (45 * 5 * 4 * 12) / 60
			} 
			if (this.selectedPlan == 2) {
				time = (45 * 5 * 4) / 60
			}
			return time 
		},
		companySavings(){
			let sum;
			if (this.selectedPlan == 1){
				sum = (45 * 5 * 4 * 12) / 60
				sum = (sum * this.hourly) * this.employees
			} 
			if (this.selectedPlan == 2) {
				sum = (45 * 5 * 4) / 60
				sum = (sum * this.hourly) * this.employees
			}
			return sum
		}
	}
}
</script>
<style>
.circle {
	border: 1px solid black;
	border-radius: 80%;
	padding: 3px;
}
</style>